/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Pressable, Text, View, Icon } from '@components/atoms'
import { Drawer as MuiDrawer } from '@mui/material'
import Badge from '@mui/material/Badge'

import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector, configActions } from '@redux/index'
import { HomeNavMenuType } from '@redux/types'
import { grey } from '@mui/material/colors'
import config from '@configs'

interface PropsType {
	menuList: HomeNavMenuType[]
}

export const HomeDrawer = (props: PropsType) => {
	const { menuList } = props

	// hook
	const navigate = useNavigate()

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isHomeOpenDrawer: boolean = useAppSelector(state => state.config.isHomeOpenDrawer)
	const isLogedin: boolean = useAppSelector(state => state.customerAuth.isLogedin)

	const customerMenuList: HomeNavMenuType[] = config.customerMenu()

	// state
	const [cartLength, setCartLength] = React.useState<number>(0)

	const onToggleClick = React.useCallback(() => {
		reduxDispatch(configActions.IS_HOME_OPEN_DRAWER(!isHomeOpenDrawer))
	}, [isHomeOpenDrawer])

	const onMenuPress = (aMenu: HomeNavMenuType) => {
		onToggleClick()
		navigate(aMenu.uri)
	}

	return (
		<MuiDrawer
			css={style}
			open={isHomeOpenDrawer}
			anchor="right"
			onClose={onToggleClick}
			variant="temporary"
		>
			<View className="homeDrawerOuterView">
				<View className="drawerTopView">
					{isLogedin ? (
						<Pressable
							className="drawerTopButton"
							onClick={() => navigate('/customer/info')}
						>
							<Icon name="account-outline" css={{ fontSize: '26px' }} />
						</Pressable>
					) : (
						<Pressable
							className="drawerTopButton"
							onClick={() => navigate('/customer/login')}
						>
							<Text>Login</Text>
						</Pressable>
					)}
				</View>

				<View className="mainMenu">
					<View className="drawerListView">
						{menuList.map(aMenu => {
							return (
								<Pressable
									key={aMenu.id}
									className="navMenuButton"
									onClick={() => onMenuPress(aMenu)}
								>
									<Text>{aMenu.title}</Text>
								</Pressable>
							)
						})}
					</View>
				</View>

				{isLogedin && (
					<View className="customerMenu">
						<View className="drawerListView">
							{customerMenuList.map(aMenu => {
								return (
									<Pressable
										key={aMenu.id}
										className="navMenuButton"
										onClick={() => onMenuPress(aMenu)}
									>
										<Text>{aMenu.title}</Text>
									</Pressable>
								)
							})}
						</View>
					</View>
				)}
			</View>
		</MuiDrawer>
	)
}

const style = css({
	'.homeDrawerOuterView': {
		maxHeight: '40rem',
	},
	'.drawerTopView': {
		width: '100%',
		marginTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey['200'],

		'.drawerTopButton': {
			width: '100%',
			height: '3rem',
		},
	},

	'.drawerListView': {
		width: '20rem',

		'.navMenuButton': {
			width: '100%',
		},
	},

	'.mainMenu': {
		marginTop: '5rem',
	},

	'.customerMenu': {
		position: 'absolute',
		bottom: 0,
		paddingBottom: '3rem',
		backgroundColor: grey[900],

		p: {
			color: 'white',
		},
	},
})
